// ClientDocumentsHub — merged Documents + Links & Sources.
// Two tabs: Documents (default file vault) and Links & Sources.
// Deep-link supported via ?view=links.
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { FolderOpen, Link2 } from 'lucide-react';
import ClientDocuments from './ClientDocuments';
import ClientLinks from './ClientLinks';

const TABS = [
  { id: 'documents', label: 'Documents', icon: FolderOpen },
  { id: 'links', label: 'Links & Sources', icon: Link2 },
];

export default function ClientDocumentsHub() {
  const [params, setParams] = useSearchParams();
  const initial = params.get('view') === 'links' ? 'links' : 'documents';
  const [tab, setTab] = useState(initial);

  useEffect(() => {
    const next = params.get('view') === 'links' ? 'links' : 'documents';
    if (next !== tab) setTab(next);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const handleTab = (id) => {
    setTab(id);
    if (id === 'documents') params.delete('view'); else params.set('view', id);
    setParams(params, { replace: true });
  };

  return (
    <div className="animate-fade-in-up" data-testid="documents-hub">
      <div className="flex items-center gap-1 border-b border-[#E6E0D9] mb-4" data-testid="documents-hub-tabs">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.id;
          return (
            <button
              key={t.id}
              onClick={() => handleTab(t.id)}
              className={cn(
                'flex items-center gap-1.5 px-4 py-2 text-sm border-b-2 -mb-px transition-colors',
                active
                  ? 'border-[#4A3B32] text-[#2C2420] font-medium'
                  : 'border-transparent text-[#5D524D] hover:text-[#2C2420]'
              )}
              data-testid={`documents-hub-tab-${t.id}`}
            >
              <Icon className="w-4 h-4" />
              {t.label}
            </button>
          );
        })}
      </div>
      {tab === 'links' ? <ClientLinks /> : <ClientDocuments />}
    </div>
  );
}
